// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { BodyText, Row, Tooltip } from '@paypalcorp/pp-react'
import { WithLoadingShimmer } from '@/common/components/loading/with-loading-shimmer'

// HELPERS
import {
  useBusinessProfilePageContent,
  useBusinessProfileReduxState,
} from '../../hooks'

// CONSTANTS
import { BUSINESS_USERNAME_SECTION_TEST_ID } from '../../constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * Shows the business username with a tooltip
 */
export function BusinessUsernameSection() {
  // STATE
  const {
    editedProfileData: { values },
  } = useBusinessProfileReduxState()

  // CONTENT
  const getContent = useBusinessProfilePageContent()
  const businessUsernameLabelText = getContent('username')
  const businessHandleTooltipText = getContent('businessHandleTooltip')

  return (
    <div
      className={styles.sectionContainer}
      data-testid={BUSINESS_USERNAME_SECTION_TEST_ID}
    >
      <Row noGutters className={styles.businessUsernameLabelContainer}>
        <BodyText strong>{businessUsernameLabelText}</BodyText>
        <Tooltip
          name='businessHandleTooltip'
          description={businessHandleTooltipText}
          screenReaderText={businessHandleTooltipText}
        />
      </Row>
      <WithLoadingShimmer isLoading={!values?.businessHandle}>
        <Row noGutters className={styles.businessUsernameContainer}>
          <BodyText>@{values?.businessHandle}</BodyText>
        </Row>
      </WithLoadingShimmer>
    </div>
  )
}
